import { yupResolver } from '@hookform/resolvers';
import ActionButton from 'components/ActionButton';
import CommonModal from 'components/CommonModal';
import { Error } from 'components/message/Error';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { exportSalesPersonReport } from 'services';
import { showError, showSuccess } from 'utils';
import * as yup from 'yup';
import styles from './index.module.scss';

const validationSchema = yup.object().shape({
  email: yup.string().required('Please enter email').email('Please enter valid email'),
});

type FormData = {
    email: string;
  };

const Export = ({ startDate, endDate, salesPersonId }: any) => {
  const [loading, setLoading] = useState(false);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);

  const { register, handleSubmit, errors } = useForm<FormData>({
    resolver: yupResolver(validationSchema),
  });

  const toggleExportModal = () => {
    setIsExportModalOpen(!isExportModalOpen);
  };

  const exportDataFn = handleSubmit(async (values) => {
    try {
      setLoading(true);
      await exportSalesPersonReport({
        endDate,
        salesPersonId,
        startDate,
        email: values?.email,
      });
      showSuccess('Data sent on mail successfully');
      toggleExportModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  });

  const getFieldError = (error) => {
    if (!error) return null;
    return <Error message={error} />;
  };

  return (
    <>
      <ActionButton
        text={'Export'}
        active={endDate && startDate && salesPersonId}
        isLoading={false}
        onClick={toggleExportModal}
        customClass={'ml-4 my-auto'}
      />
      {isExportModalOpen ? <CommonModal title={'Export sales person report'}
        cancellable
        toggleModal={toggleExportModal}
        primaryButtonText="Export"
        primaryButtonOnClick={exportDataFn}
        secondaryButtonText="Close"
        secondaryButtonOnClick={toggleExportModal}
      >
        <div className={styles['name']}>
          <div className={styles['label']}>Email Id*</div>
          <input
            name={'email'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
          {getFieldError(errors?.email?.message)}
        </div>
      </CommonModal> : null}
    </>
  );
};

export default Export;